import {Component, inject, input, OnDestroy, ViewChild} from '@angular/core';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {NgbTooltip} from '@ng-bootstrap/ng-bootstrap';
import {CustomFormControl} from '../CustomFormControl';
import {FormHelperService} from '../../../services/form-helper.service';
import {Subscription} from 'rxjs';

@Component({
  selector: 'app-personal-property-input',
  standalone: true,
  imports: [
    FormsModule,
    NgbTooltip,
    ReactiveFormsModule
  ],
  templateUrl: './personal-property-input.component.html',
  styleUrl: './personal-property-input.component.scss'
})
export class PersonalPropertyInputComponent implements OnDestroy {
  isValidating = false;
  @ViewChild('loadingTooltip') tooltip: NgbTooltip | undefined;
  control = input.required<CustomFormControl>();
  public formHelper = inject(FormHelperService);

  private statusSub?: Subscription;

  ngAfterViewInit(): void {
    // Subscribe to status changes on the control
    this.statusSub = this.control().statusChanges.subscribe(status => {
      this.isValidating = status === 'PENDING';
      if (this.isValidating && this.tooltip) {
        this.tooltip.open();
      } else if (!this.isValidating && this.tooltip) {
        this.tooltip.close();
      }
    });
  }

  ngOnDestroy(): void {
    this.statusSub?.unsubscribe();
  }
}
